import React, { useState } from "react";
import style from './blackfridaycard.module.scss';
import { Link } from "react-router-dom"
import toPersianNumber from "../../../../helpers/actions/toPersianNumber"
import numberWithCommas from "../../../../helpers/actions/numberWithCommas"

const ProReportCard = (props) => {

    const [moreInfo, setMoreInfo] = useState(false)

    const calculateLines = text => {
        if (text.length < 88) {
            return text
        } else {
            return text.substr(0, 80) + '...'
        }
    }

    return (
        <div className={style.wrapper}>
            <div className={style.newFlexWrapper}>
                <div className={`${style.flexItem} ${style.flexItem303}`}>
                    <div className={style.nameStyle}>
                        <Link
                            className={style.name}
                            style={{ textDecoration: "none" }}
                            to={{ pathname: `https://www.digikala.com/product/dkp-${props.data.DKP}` }}
                            target="_blank"
                        >
                            <div className={style.nameWrapper}>
                                <p
                                    className={style.realName}
                                >
                                    {calculateLines(toPersianNumber(props.data.product_name_fa))}
                                </p>
                            </div>
                        </Link>
                    </div>
                    <div className={style.channelPromotion}>
                        <p className={style.channelText}>DKP - {toPersianNumber(props.data.DKP)}</p>
                    </div>
                </div>

                <div className={style.flexItem175}>{props.data.leafcat_name}</div>
                <div className={style.flexItem175}>{toPersianNumber(numberWithCommas(parseInt(props.data.avg_selling_price)))}</div>
                <div className={style.flexItem175}>{toPersianNumber(props.data.number_of_sellers)}</div>
                <div
                    onClick={() => setMoreInfo(!moreInfo)}
                    className={style.flexItem175}
                >
                    <div className={style.moreInfoArrowBox}>
                        <div className={moreInfo ? style.moreInfoArrowActive : style.moreInfoArrow}></div>
                    </div>
                    <p>جزئیات</p>
                </div>
            </div>
            {/* moreInfo */}
            {moreInfo && <div className={style.moreInfoWrapper}>
                <div className={style.item}>
                    <p className={style.label}>حداقل درصد پیشنهادی تخفیف</p>
                    <p className={style.value}>{props.data.Recommaded_discount1 ? toPersianNumber(props.data.Recommaded_discount1) : 'نامشخص'}</p>
                </div>
                <div className={style.devider}></div>
                <div className={style.item}>
                    <p className={style.label}>حداکثر درصد پیشنهادی تخفیف</p>
                    <p className={style.value}>{props.data.Recommaded_discount2 ? toPersianNumber(props.data.Recommaded_discount2) : 'نامشخص'}</p>
                </div>
                <div className={style.devider}></div>
                <div className={style.item}>
                    <p className={style.label}>پیش‌بینی حد پایین ناخالص فروش</p>
                    <p className={style.value}>{props.data.lowerNmv ? toPersianNumber(numberWithCommas(parseInt(props.data.lowerNmv))) + ' ریال ' : 'نامشخص'}</p>
                </div>
                <div className={style.devider}></div>
                <div className={style.item}>
                    <p className={style.label}>پیش‌بینی حد بالای ناخالص فروش</p>
                    <p className={style.value}>{props.data.upperNmv ? toPersianNumber(numberWithCommas(parseInt(props.data.upperNmv))) + ' ریال ' : 'نامشخص'}</p>
                </div>
                <div className={style.devider}></div>
                <div className={style.item}>
                    <p className={style.label}>پیش‌بینی حد پایین ناخالص فروش با اعمال تخفیف</p>
                    <p className={style.value}>{props.data.lowerNmvWithDiscount ? toPersianNumber(numberWithCommas(parseInt(props.data.lowerNmvWithDiscount))) + ' ریال ' : 'نامشخص'}</p>
                </div>
                <div className={style.devider}></div>
                <div className={style.item}>
                    <p className={style.label}>پیش‌بینی حد بالای ناخالص فروش با اعمال تخفیف</p>
                    <p className={style.value}>{props.data.upperNmvWithDiscount ? toPersianNumber(numberWithCommas(parseInt(props.data.upperNmvWithDiscount))) + ' ریال ' : 'نامشخص'}</p>
                </div>
            </div>}
        </div>
    )
}
export default ProReportCard